export default __webpack_public_path__ + "2e0e45404aa0c554e140258d299f30f2.svg";